import type { BlockType } from '@backmarket/http-api/src/api-specs-content'

import { getDimensionProperties as getDimensionPropertiesFn } from '~/scopes/cms/helpers/block-width.helper'

// FIXME: use directly scopes/cms getDimensionProperties in ArticleBlockContainer
export function getDimensionProperties(type: BlockType) {
  return getDimensionPropertiesFn(type)
}
